import axios from "axios";
import { paramsSerializer } from "../../../../../../../../utils";

export const fetchLocale = async (props) => {
  const { assetUrl, authToken, apiKey, branch } = props;
  const url = `${assetUrl}/locales`;
  try {
    const headers = {
      api_key: apiKey,
      'Content-Type': 'application/json'
    }
    authToken && (headers['authToken'] = authToken);
    branch && (headers['branch'] = branch);
    const res = await axios({
      method: 'GET',
      url,
      headers,
      paramsSerializer
    });
    const json = await res.data;
    const locales = {};
    json['locales'].forEach(env => locales[env['code']] = env['name']);
    return locales;
  } catch (err) {
    // console.error(err);
    return {};
  }
}
